import type { ReactNode } from "react";
import { Link } from "react-router-dom";

interface SectionHeaderProps {
  eyebrow?: string;
  title: string;
  subtitle?: string;
  moreTo?: string;
  moreLabel?: string;
  action?: ReactNode;
}

export default function SectionHeader({
  eyebrow,
  title,
  subtitle,
  moreTo,
  moreLabel = "查看全部",
  action,
}: SectionHeaderProps) {
  return (
    <div className="mb-6 flex flex-wrap items-end justify-between gap-4">
      <div>
        {eyebrow && (
          <span className="mb-2 inline-flex items-center gap-1.5 rounded-full bg-primary-100 px-3 py-1 text-xs font-bold text-primary-700">
            <i className="ri-fire-fill"></i>
            {eyebrow}
          </span>
        )}
        <h2 className="text-xl font-black text-foreground-900 md:text-2xl">{title}</h2>
        {subtitle && <p className="mt-1.5 max-w-2xl text-sm text-foreground-500">{subtitle}</p>}
      </div>
      {action}
      {moreTo && !action && (
        <Link
          to={moreTo}
          className="inline-flex items-center gap-1 whitespace-nowrap rounded-md border border-background-200 bg-background-50 px-3 py-2 text-sm font-medium text-foreground-700 transition hover:border-primary-300 hover:text-primary-600"
        >
          {moreLabel}
          <i className="ri-arrow-right-s-line"></i>
        </Link>
      )}
    </div>
  );
}